<template>
	<div class="report-section alarm-section">
		<section-header :number="'03'" title="告警监控" />
		<div class="section-content">
			<div class="stats-grid" pdf-truncation-check-point>
				<stat-card
					label="本期告警次数"
					:value="data.alarmCount"
					:icon="chanShengGaoJing"
					backgroundColor="#edf8fe"
					unit="次"
				/>
				<stat-card
					v-if="type !== 3"
					label="同比"
					:value="data.alarmCountYoy"
					unit="%"
					:trend="data.alarmCountYoy"
					:icon="tongBi"
					backgroundColor="#edf0ff"
				/>
				<stat-card
					label="环比"
					:value="data.alarmCountMom"
					unit="%"
					:trend="data.alarmCountMom"
					:icon="huanBi"
					backgroundColor="#ece4f7"
				/>
			</div>

			<div class="charts-row">
				<Panel title="本期告警按设备大类分布" class="chart-container" pdf-truncation-check-point>
					<pie-chart :chart-options="alarmTypeOptions" height="190px" />
				</Panel>
				<Panel title="本期告警按告警类型统计Top5" class="chart-container" pdf-truncation-check-point>
					<horizontal-bar-chart :chart-options="alarmLevelOptions" height="190px" />
				</Panel>
			</div>

			<div class="charts-row">
				<Panel title="本期告警处理情况" class="chart-container" pdf-truncation-check-point>
					<bar-chart :chart-options="alarmProcessingOptions" height="190px" chart-style="blue" />
				</Panel>
				<Panel title="截止本期所有告警处理情况" class="chart-container" pdf-truncation-check-point>
					<bar-chart :chart-options="alarmProcessingTimeOptions" height="190px" chart-style="blue" />
				</Panel>
			</div>

			<!-- 告警处理类型分布 -->
			<Panel title="截止本期所有告警逾期未处理统计" class="chart-container full-width" pdf-truncation-check-point>
				<bar-chart :chart-options="alarmProcessingTypeOptions" height="190px" chart-style="blue" />
			</Panel>

			<!-- 告警详情表格 -->
			<Panel title="截止本期所有告警逾期未处理天数Top5" class="table-container" pdf-truncation-check-point>
				<table-base :columns="alarmDetailColumns" :data="data.alarmOverdueDetail || []" />
			</Panel>
		</div>
	</div>
</template>

<script>
import TableBase from '../components/tableBase.vue'
import SectionHeader from '../components/SectionHeader.vue'
import StatCard from '../components/StatCard.vue'
import huanBi from '../icons/huanbi.png'
import tongBi from '../icons/tongbi.png'
import chanShengGaoJing from '../icons/chanshenggaojing.png'
import Panel from '../components/panel.vue'
import PieChart from '../components/pieChart.vue'
import HorizontalBarChart from '../components/horizontalBarChart.vue'
import BarChart from '../components/barChart.vue'
import { fillMissingData } from '../components/chartMixin.js'

export default {
	name: 'AlarmSection',
	components: {
		TableBase,
		SectionHeader,
		StatCard,
		Panel,
		PieChart,
		HorizontalBarChart,
		BarChart,
	},
	props: {
		data: {
			type: Object,
			default: () => {},
		},
		type: {
			type: Number,
			default: 1,
		},
	},
	data() {
		return {
			chanShengGaoJing,
			tongBi,
			huanBi,

			// 告警详情表格列配置
			alarmDetailColumns: [
				{ prop: 'username', label: '客户名称' },
				{ prop: 'deviceNo', label: '设备通讯编号' },
				{ prop: 'deviceType', label: '设备类型' },
				{ prop: 'alarmName', label: '告警名称' },
				{ prop: 'alarmLevel', label: '告警等级', align: 'center', width: 72 },
				{ prop: 'alarmTime', label: '告警时间' },
				{ prop: 'diffday', label: '逾期天数', align: 'right', width: 72 },
			],
		}
	},
	computed: {
		// 告警类型饼图配置
		alarmTypeOptions() {
			const data = this.data.typeClassifyAlarmCount || []
			return {
				series: [
					{
						data: data.map(item => {
							return { value: item.count, name: item.type }
						}),
					},
				],
			}
		},

		// 告警等级分布柱状图配置
		alarmLevelOptions() {
			const data = (this.data.alarmTypeAlarmCount || []).sort((a, b) => a.count - b.count)
			return {
				yAxis: {
					data: data.map(item => item.type),
				},
				series: [
					{
						data: data.map(item => item.count),
					},
				],
			}
		},

		// 告警处理情况柱状图配置
		alarmProcessingOptions() {
			let data = this.data.alarmLevelAlarmCount || []
			data = fillMissingData(data, ['一般', '中等', '严重'], ['processedCount', 'untreatedCount'], 'alarmLevel')

			return {
				xAxis: {
					data: data.map(item => item.alarmLevel),
				},
				series: [
					{
						name: '已处理',
						data: data.map(item => item.processedCount),
					},
					{
						name: '未处理',
						data: data.map(item => item.untreatedCount),
					},
				],
			}
		},

		// 告警处理时长分布柱状图配置
		alarmProcessingTimeOptions() {
			let data = this.data.alarmLevelAlarmCountEnd || []
			data = fillMissingData(data, ['一般', '中等', '严重'], ['processedCount', 'untreatedCount'], 'alarmLevel')
			return {
				xAxis: {
					data: data.map(item => item.alarmLevel),
				},
				series: [
					{
						name: '已处理',
						data: data.map(item => item.processedCount),
					},
					{
						name: '未处理',
						data: data.map(item => item.untreatedCount),
					},
				],
			}
		},

		// 告警处理类型分布柱状图配置
		alarmProcessingTypeOptions() {
			let data = this.data.alarmOverdueCount || []
			data = fillMissingData(
				data,
				['0-7天', '8-15天', '15-30天', '超过30天'],
				['level1Count', 'level2Count', 'level3Count'],
				'diffDay',
			)
			return {
				xAxis: {
					data: data.map(item => item.diffDay),
				},
				series: [
					{
						name: '一般',
						data: data.map(item => item.level1Count),
					},
					{
						name: '中等',
						data: data.map(item => item.level2Count),
					},
					{
						name: '严重',
						data: data.map(item => item.level3Count),
					},
				],
			}
		},
	},
}
</script>

<style scoped lang="scss">
.device-status-columns {
	width: 100%;
}
</style>
